export const productApiUrl = {
  getProducts: "/product",
  getProductLotById: "/product/lot",
  getProductById: "/product/id",
  addProducts: "/product/add",
  updateProduct: "/product/update",
  deleteProduct: "/product/delete",
  taskForProduct: "/product/task",
  assignPMCToProduct: "/product/assign-pmc",
  pmcChecklistUpdate: "/product/update-pmc-checklist",
  getPmcChecklist: "/product/pmc-checklist",
  updateExecutionTimeline: "/product/update-execution-timeline",
  initiateTaskForExecutionTimeline: "/product/initiate-task-for-timeline",
  approveChecklist: "/product/approve-checklist",
  approveExecutionTimeline: "/product/approve-execution-timeline",
  getExecutionTimeline: "/product/execution-timeline",
  getExecutionTimelineLogs: "/product/execution-timeline-logs",
  getInputOutputForProductExecutionTimeline: "/product/input-output",
  updateInputOutput: "/product/update-input-output",
  pmcAssignStatus: "/product/status-pmc-assign",
  executionTimelineTaskStatus: "/product/execution-timeline-task-status",
  getTaskFromLotId: "/product/tasks-by-lotId",
  getExecutionTimelineAssignee: "/product/execution-timeline-assignee",
  getExecutionTimelineAssigneeByLotId:
    "/product/execution-timeline-assignee-by-lot-id",
};
